const viewNames = {
  MethodSelection: 'MethodSelection',
  SmartIdAuth: 'SmartIdAuth',
  MobileIdAuth: 'MobileIdAuth',
  IdentificationFrejaId: 'IdentificationFrejaId',
  IdentificationZealId: 'IdentificationZealId',
  SignatureSmartId: 'SignatureSmartId',
  SignatureMobileId: 'SignatureMobileId',
  SignatureFtn: 'SignatureFtn',
  SignatureFtnAdvancedFull: 'SignatureFtnAdvancedFull',
  SignatureOtp: 'SignatureOtp',
  SignatureEvrotrust: 'SignatureEvrotrust',
  SignatureDTrustSignMe: 'SignatureDTrustSignMe',
  SignatureChaveMovel: 'SignatureChaveMovel',
  SignatureNoBankId: 'SignatureNoBankId',
  SignatureSpidQes: 'SignatureSpidQes',
  SignatureFrejaId: 'SignatureFrejaId',
  SignatureAudkenni: 'SignatureAudkenni',
  SignatureSimplySign: 'SignatureSimplySign',
};

export default viewNames;
